import { render, staticRenderFns } from "./offer_all.vue?vue&type=template&id=484b8ab8&scoped=true&"
import script from "./offer_all.vue?vue&type=script&lang=js&"
export * from "./offer_all.vue?vue&type=script&lang=js&"
import style0 from "./offer_all.vue?vue&type=style&index=0&id=484b8ab8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b8ab8",
  null
  
)

export default component.exports